module.exports = __webpack_public_path__ + "static/media/ic-expand-arrows.d52f3e17.svg";